export default __webpack_public_path__ + "static/media/undraw_community_8nwl.b7fbf410.svg";